import React from 'react';
import { Typography } from 'ui';
import { TypeScales } from 'ui/primitives';
import Markdown from 'markdown-to-jsx';
import s from './ScrollableJumbo.module.scss';

export const ScrollableJumbo = ({ heading, description }) => (
  <div className={s.root}>
    <Typography label={heading} variant={TypeScales.h3} className={s.heading} />
    <div className={s.description}>
      <Markdown>{description}</Markdown>
    </div>
  </div>
);
